// mapThemeStyles.js

import { ThemeMode } from 'context/ThemeContext';

// Ref: Google Maps JS Styled Maps (featureType/elementType/stylers)
// Keep these arrays centralized so both full and compact map views stay in sync.
export const MAP_STYLE_LIGHT = [
  { elementType: 'geometry', stylers: [{ color: '#f5f6f8' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#4b5563' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f6f8' }] },
  { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#d7dbe2' }] },
  { featureType: 'administrative.land_parcel', elementType: 'geometry.stroke', stylers: [{ color: '#d7dbe2' }] },
  { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#fofofo' }] },
  { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#e4e8ee' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#d8e7d7' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
  { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#f7f7f9' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#e5e8ef' }] },
  { featureType: 'road.highway.controlled_access', elementType: 'geometry', stylers: [{ color: '#d9dee8' }] },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#d8dde7' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9def5' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#406a94' }] },
];

export const MAP_STYLE_DARK = [
  { elementType: 'geometry', stylers: [{ color: '#212121' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#c3cad5' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#1f2329' }] },
  { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#3a414d' }] },
  { featureType: 'administrative.land_parcel', elementType: 'geometry.stroke', stylers: [{ color: '#3a414d' }] },
  { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#212121' }] },
  { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#2a3039' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#27362c' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#303844' }] },
  { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#343e4b' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#465160' }] },
  { featureType: 'road.highway.controlled_access', elementType: 'geometry', stylers: [{ color: '#536073' }] },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#36404f' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#1f3245' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#8ab0d6' }] },
];

export const getMapStylesByThemeMode = (themeMode) => (
  themeMode === ThemeMode.LIGHT ? MAP_STYLE_LIGHT : MAP_STYLE_DARK
);
